var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"p-1 mb-1 rounded-full dark:text-slate-500 dark:bg-slate-900 text-slate-600 bg-slate-100 hover:text-slate-800",on:{"click":function($event){return _vm.$emit('click')}}},[_c('FluentIcon',{staticClass:"flex-shrink-0",attrs:{"icon":"arrow-reply","size":"11"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }